export default "__VITE_ASSET__CpVtqDqx__"